import { render, staticRenderFns } from "./OnlyExchange.vue?vue&type=template&id=6987673c&scoped=true"
import script from "./OnlyExchange.vue?vue&type=script&lang=js"
export * from "./OnlyExchange.vue?vue&type=script&lang=js"
import style0 from "./OnlyExchange.vue?vue&type=style&index=0&id=6987673c&prod&scoped=true&lang=css"
import style1 from "./OnlyExchange.vue?vue&type=style&index=1&id=6987673c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6987673c",
  null
  
)

export default component.exports